import React, { useContext, useEffect } from "react";
import {Context} from "..";
import { getProducts } from "../http/productAPI";

import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ProductList from "../components/ProductList";
import '../components/FrontProductsBlock.css';
import { promotionMetaByName } from "../utils/promotionUtils";


const PromotionsPage = () => {
  const navigate = useNavigate();
  const {user, product} = useContext(Context)
    product.setSelectedFilters({"Бесплатный монтаж": ["1"]});
    const selectedFolderFilters = product.requestBodyFilter;       
    product.setSelectedFolder({ id: "2" });

    useEffect(() => {
        getProducts(product.selectedFolder.id, 0, 20, selectedFolderFilters).then(data => {
          //console.log("Response from backend:", data);
            product.setProducts(data.products);
            product.setFilters(data.filters);
        })
        .catch(error => {
            console.log("Ошибка при получении продуктов: SubCatalogList useEffect", error);
        });
      }, [product.search, product.selectedFolder])

  return (
    <div className="py-4">
    <Container className="py-5">
      <h1 className="mb-4 text-center">Актуальные акции</h1>
      <Row>
        {product.filters
          .filter(f => f.order >= 13 && promotionMetaByName[f.name])
          .map((filter, idx) => {
            const { key, image, description } = promotionMetaByName[filter.name];
          
            return (
              <Col key={idx} md={6} lg={4} className="mb-4">
                <Card
                  onClick={() => navigate(`/catalog/wall_split_system?${key}`)}                 
                  className="h-100 shadow-sm promo-card"
                  style={{ cursor: 'pointer' }}
                >
                  <Card.Img
                    variant="top"
                    src={require(`../assets/img/${image}`)}
                    alt={filter.name}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <Card.Body>
                    <Card.Title>{filter.name}</Card.Title>
                    <Card.Text>{description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
      </Row>
                

    </Container>

    <Container className="mb-4 products d-flex justify-content-start flex-wrap align-items-stretch px-0">
                <ProductList/>                  
     </Container>
     </div>
  );
};

export default PromotionsPage;
